"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    notification.classList.add("notification", type);
    notification.style.top = posTop + "px";
    notification.style.right = posRight + "px";
    var notificationTitle = document.createElement("h2");
    notificationTitle.classList.add("title");
    notificationTitle.textContent = title;
    notification.appendChild(notificationTitle);
    var notificationDescription = document.createElement("p");
    notificationDescription.textContent = description;
    notification.appendChild(notificationDescription);
    document.body.appendChild(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.b7a624a2.js.map
